import { MatDialog} from '@angular/material/dialog';

export class MessageBoxParameter {
    dialog: MatDialog;
    title?: string;
    message?: string;
    information?: string;
    buttons?: string[];
    width?: string;
    style?: number;
    allow_outside_click?: boolean;
    constructor() {
        this.style = 0;
        this.buttons = [];
        this.allow_outside_click = false;
    }
}
